import { LoadingSpinner } from './loading-spinner'

interface FullPageSpinnerProps {
	message?: string
}

export function FullPageSpinner({ message = 'Loading...' }: FullPageSpinnerProps) {
	return (
		<div className="flex items-center justify-center min-h-screen">
			<div className="flex flex-col items-center gap-3">
				<LoadingSpinner size="lg" />
				<div className="text-sm text-muted-foreground">{message}</div>
			</div>
		</div>
	)
}
